/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { ReduxUtils } from '@spm/core';
import Constants from '../App/constants';
import RESOURCE_NAMES from '../App/resources';
/**
 * Generate the action types for withdraw request reasons.
 *
 * @param {string} LIBRARY_ROOT The folder name
 * @param {string} resource The withdraw request reason resource
 * @returns {*} The withdraw request reason action types
 */

var withdrawRequestReasonsActionTypes = ReduxUtils.generateActionTypes(Constants.LIBRARY_ROOT, RESOURCE_NAMES.withdrawRequestReasons);
export default {
  withdrawRequestReasonsActionTypes: withdrawRequestReasonsActionTypes
};